import {
	Box,
	Card,
	styled,
} from '@mui/material'

export const RadioGroupBlockGrid = styled('div')<{
	columns: number
}>(({
	theme,
	columns,
}) => {
	return {
		display:                        'grid',
		gridTemplateColumns:            `repeat(${String(columns)}, 1fr)`,
		gap:                            theme.spacing(2),
		width:                          '100%',
	}
})

export const RadioGroupBlockItemCard = styled(Card)<{
	selected: boolean
}>(({
	selected,
}) => {
	return {
		cursor:          'pointer',
		transition:      'all 0.2s ease-in-out',
		borderColor:     selected ?
			'var(--positive-color-opacity-40)' :
			'var(--outline-color-base)',
		backgroundColor: selected ?
			`var(--surface-container-dim-color)` :
			'var(--surface-container-color)',

		'&:hover':     {
			borderColor: 'var(--positive-color-opacity-60)',
			transform:   'translateY(-2px)',
			boxShadow:   'var(--base-box-shadow)',
		},
	}
})

export const RadioGroupBlockItemImage = styled(Box)`
	position: relative;
	padding-bottom: 80%;
	
	img {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		object-fit: cover;
	}
`

export const RadioGroupBlockItemContent = styled(Box)`
	display: flex;
	flex-direction: column;
	padding: var(--base-spacing-2) var(--base-spacing-1);
	gap: var(--base-spacing-1);
	align-items: flex-start;
	justify-content: center;
`
